export function humanizeFileSize(bytes: number) {
    const threshold = 1024;
    const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    while (Math.abs(bytes) >= threshold && units.length > 0) {
        bytes /= 1024;
        units.shift();
    }
    return `${bytes.toFixed(1)} ${units[0]}`;
}
